import { showPopup } from '../elements/popup/showpopup.js';
import { animateBounceFadeInOutRepeat } from '../functions/animation.js';

class CircleShape {

    constructor(x, y, width, title, icon_image, url, icon_image_hover, kirbycontent ) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.title = title;
        this.url = url;
        this.icon_image = icon_image;
        this.icon_image_hover = icon_image_hover;
        this.kirbycontent = kirbycontent;
        this.addMarker();
    }

    addMarker() {
        // 1. Maak een anker-container die uitsluitend de (x, y) positie en centrering regelt
        var marker_anchor = document.createElement('div');
        marker_anchor.style.position = "absolute";
        marker_anchor.style.left = this.x + 'px';
        marker_anchor.style.top = this.y + 'px';
        marker_anchor.style.transform = "translate(-50%, -50%)";

        // 2. Binnenste elementen
        var marker_container = document.createElement('div');
        var marker_text = document.createElement('div');
        var icon = document.createElement('img');
        var marker = document.createElement('div');
        var ring_container = document.createElement('div');

        var map = document.querySelector('.hoofdbeeld');

        ring_container.classList.add('icon_image');
        ring_container.style.width = this.width + "px";
        icon.src = this.icon_image;
        ring_container.appendChild(icon);

        marker_container.appendChild(ring_container);
        marker_container.classList.add('marker');
        marker_container.style.display = "flex";
        marker_container.style.justifyContent = "center";
        marker_container.style.alignItems = "center";
        marker_container.style.transformOrigin = "center center";

        marker.classList.add('icon');

        // Voeg marker_container toe aan de anchor, en anchor aan de map
        marker_anchor.appendChild(marker_container);
        map.appendChild(marker_anchor);

        // 3. Animeer HET BINNENSTE element (zo blijft translate(-50%, -50%) op de anchor intact)
        animateBounceFadeInOutRepeat(marker_container);

        marker_anchor.addEventListener('click', (event) => {
            showPopup(this.url, this.kirbycontent);
        });

        marker_anchor.addEventListener('mouseover', (event) => {
            icon.src = this.icon_image_hover;
            marker_container.appendChild(marker_text);
            marker_text.innerText = this.title;
            marker_text.classList = 'markertext';
        });

        marker_anchor.addEventListener('mouseout', (event) => {
            icon.src = this.icon_image;
            if (marker_container.contains(marker_text)) {
                marker_container.removeChild(marker_text);
            }
        });
    }
}

window.CircleShape = CircleShape;

export default CircleShape;